import { learningObjectActions } from '../ActionTypes';
import { updateState } from '../../middlewares/utils';

const initialFormData = {
  Id: '0',
  Name: '',
  Description: '',
  Type: '',
  VimeoURL: '',
  YoutubeURL: '',
  Content: ''
};

const defaultState = {
  lobjList: [],
  tableLoading: false,
  form: initialFormData,
  formLoading: false,
  formError: null,
  deleteId: null
};


export default (state = defaultState, actions) => {
  switch (actions.type) {
    case learningObjectActions.LOBJ_FETCH_START:
      return updateState(state, { tableLoading: true });
    case learningObjectActions.LOBJ_FETCH_SUCCESS:
      return updateState(state, { tableLoading: false, lobjList: actions.payload });
    case learningObjectActions.LOBJ_FETCH_ERROR:
      return updateState(state, { tableLoading: false, ...actions.payload });
    case learningObjectActions.LOBJ_SAVE_START:
      return updateState(state, { formLoading: true, formError: null, form: initialFormData });
    case learningObjectActions.LOBJ_SAVE_SUCCESS:
      return updateState(state, { formLoading: false, form: initialFormData });
    case learningObjectActions.LOBJ_SAVE_FAILED:
      return updateState(state, { formLoading: false, ...actions.payload });
    case learningObjectActions.LOBJ_SET_FORM:
      return updateState(state, { ...actions.payload, formError: null });
    case learningObjectActions.LOBJ_RESET_FORM:
      return updateState(state, { form: initialFormData });
    default:
      return state;
  }
};
